const API_SERVER = 'https://portal-weizman-legacy.polpodev.com/api';

export default function toAPIPath(paths) {
  return `${API_SERVER}/${paths.join('/')}`;
}
